import { Observable } from 'windowed-observable';
import { useObservable } from './useObservable';
import { NavigationFilter } from '../utils/queryParams';

const observable: Observable<NavigationFilter[]> = new Observable<
  NavigationFilter[]
>('navigation-filters');

export const useFiltersObservable = () => useObservable(observable, []);
